<script lang="ts">
	import type { ButtonVariant } from "./ButtonProps";
	import Icon from "./Icon.svelte";

	const variantToBackgroundMap: Record<ButtonVariant, string> = {
		primary: "bg-ltprimary-100",
		secondary: "bg-ltprimary-100",
		primaryTransparent: "bg-lttertiary-100",
		secondaryTransparent: "bg-white",
		tertiary: "bg-transparent",
		whiteTertiary: "bg-transparent",
		underline: "hidden",
		active: "",
		custom: "",
	};

	const variantToIconColorMap: Record<ButtonVariant, string> = {
		primary: "text-white",
		underline: "text-inherit",
		secondary: "text-white",
		primaryTransparent: "text-ltprimary-300",
		secondaryTransparent: "text-ltprimary-300 hover:text-ltprimary-100 group-active:text-ltprimary-100",
		tertiary: "text-inherit",
		whiteTertiary: "text-inherit",
		active: "",
		custom: "",
	};

	export let disabled: boolean | null;
	export let iconClass: string | undefined;
	export let variant: ButtonVariant;
	export let icon: string;
</script>

<Icon
	{icon}
	class="relative z-10 max-w-9 {disabled ? 'text-ltsecondary-300' : variantToIconColorMap[variant]} {iconClass ?? ''}"
/>
<div class="absolute inset-y-1 right-1 rounded-[1.25rem] {variantToBackgroundMap[variant]}"></div>

<style>
	div {
		left: calc(100% - 2.5rem - 0.25rem);
		transition: left 300ms ease;
	}

	@media (hover: hover) {
		:global(.group:hover) > div {
			left: 0.25rem;
		}
	}

	:global(.group:active) > div {
		left: 0.25rem;
	}
</style>
